
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.173 9.23a4.034 4.034 0 10-6.3 0l.003.004c.118.146.226.3.339.45.196.26.472.624.793 1.043.598.782 1.345 1.745 2.015 2.572.672-.828 1.421-1.793 2.02-2.576.322-.42.598-.785.794-1.045.113-.148.22-.303.336-.449zm1.045.837l-.002.003c-.034.046-.349.466-.804 1.064-.676.887-1.663 2.167-2.506 3.199a1.133 1.133 0 01-1.766 0c-1.442-1.766-3.306-4.262-3.306-4.262l-.005-.005a5.371 5.371 0 118.39-.004l-.002.002-.001.002h.003l-.001.001z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.022 7.354a.669.669 0 100-1.337.669.669 0 000 1.337zm2.006-.669a2.006 2.006 0 11-4.011 0 2.006 2.006 0 014.01 0z","fill":"currentColor"}})])
          )
        }
      }
    